import { useMutation, useQuery, useQueryClient } from "react-query";
import { Storage } from "utils/clientStorage";
import { Signer } from "utils/signpin";
import clientApi from "./client";
import { beneficiary, sendToBeneficiary, updateBeneficiary } from "./routes";

// ---------- GET BENEFICIARIES -----------

const getBeneficiaries = async () => {
  const { data } = await clientApi.get(beneficiary);
  return data;
};

export const useGetBeneficiaries = () => {
  return useQuery("get-beneficiary", async() => {
    const res = await getBeneficiaries();
    return res.data
  });
};

// ---------- ADD BENEFICIARY -----------

export const postBeneficiary = (data) => {
  return clientApi.post(beneficiary, data);
};

const updateBeneficiaryAction = (data) => {
  return clientApi.post(updateBeneficiary(data.beneficiaryId), data);
};

export const useUpdatebeneficiary = (setConfirmModal, setErrorModal) => {
  const queryClient = useQueryClient();
  return useMutation(updateBeneficiaryAction, {
    onSuccess: () => {
      queryClient.invalidateQueries("get-beneficiary");
      setConfirmModal?.(true);

    },
    onError: () => {
      setErrorModal?.(true);
    },
  });
};

const deleteBeneficiaryAction = (data) => {
  return clientApi.delete(updateBeneficiary(data.beneficiaryId), data);
};

export const useDeletebeneficiary = (setConfirmModal, setErrorModal) => {
  const queryClient = useQueryClient();
  return useMutation(deleteBeneficiaryAction, {
    onSuccess: () => {
      queryClient.invalidateQueries("get-beneficiary");
      setConfirmModal?.(true);

    },
    onError: () => {
      setErrorModal?.(true);
    },
  });
};



// ---------- SEND TO BENEFICIARY -----------

export const handleSendToBeneficiary = async (beneficiaryId, amount,pin) => {
  const token = window !== undefined ? Storage.getItem("TOKEN") || "" :""
      var api = sendToBeneficiary(beneficiaryId, amount);
      var nonce = Signer.nonce();
      var signature = await Signer.digest(pin, nonce, api);
  const { data } = await clientApi.get(
    api,
    {
      headers: {
        				'Nonce': nonce,
        				'Signature': signature,
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`, // Input token
                "Access-Control-Allow-Origin": "*"
        			}
    }
  );
  return data;
};


